import { getApiClient } from '@core/api/client';
import type { DocumentBlock, GetDocumentContentResponse } from '@core/types/document';

const PAGE_SIZE = 200;

async function fetchBlockPage(documentId: string, cursor: string): Promise<GetDocumentContentResponse> {
  return getApiClient().get<GetDocumentContentResponse>(
    `/document/documents/${encodeURIComponent(documentId)}/blocks`,
    { params: { pagination: { limit: PAGE_SIZE, ...(cursor ? { cursor } : {}) } } },
  );
}

/** Load all top-level blocks before enabling edits; a partial document must never be saved as the whole document. */
export async function loadAllDocumentBlocks(
  documentId: string,
  fetchPage: (documentId: string, cursor: string) => Promise<GetDocumentContentResponse> = fetchBlockPage,
): Promise<DocumentBlock[]> {
  const blocks: DocumentBlock[] = [];
  const seenCursors = new Set<string>();
  let cursor = '';
  for (;;) {
    const page = await fetchPage(documentId, cursor);
    blocks.push(...(page.blocks ?? []));
    const info = page.pagination?.page_info;
    if (!info?.has_next) return blocks;
    if (!info.next_cursor || seenCursors.has(info.next_cursor)) {
      throw new Error('Document content pagination did not advance');
    }
    seenCursors.add(info.next_cursor);
    cursor = info.next_cursor;
  }
}
